module.exports = __webpack_public_path__ + "img/bg-mobile.ee5df150.png";